import { createPinia } from 'pinia'

import { useUserStore } from './user'
import { useAppStore } from './app'
import { useWwStore } from './ww'

const pinia = createPinia()

// Root store for initialization state
export const useRootStore = {
  state: {
    init: false
  }
}

// Initialize store function - call this in App.vue
export async function initStore() {
  const userStore = useUserStore()
  const wwStore = useWwStore()

  await Promise.all([userStore.loadUser(), userStore.loadGroups()])

  // useRootStore.state.init = true

  // Load additional data in background
  Promise.all([
    userStore.loadEmailAlerts(),
    userStore.loadTrackedBacktests(),
    userStore.loadInsiderAlerts(),
    wwStore.loadQuarters(),
    wwStore.loadSectors(),
    wwStore.loadClassifications(),
    wwStore.loadCountries(),
    wwStore.loadSECCodeStates(),
    wwStore.loadStates(),
    wwStore.loadWWGroups(),
    wwStore.loadOwnershipTCodes(),
    userStore.loadWatchlists()
  ])
}

export async function initFilerStore() {
  const userStore = useUserStore()
  const wwStore = useWwStore()

  await Promise.all([userStore.loadUser(), userStore.loadGroups()])

  //useRootStore.state.init = true

  // Load additional data in background
  Promise.all([
    wwStore.loadQuarters(),
    wwStore.loadSectors(),
    wwStore.loadClassifications(),
    wwStore.loadWWGroups()
  ])
}

export { useUserStore, useAppStore, useWwStore }
export default pinia
